import { render, staticRenderFns } from "./new-contact-form.vue?vue&type=template&id=7346062a&scoped=true"
import script from "./new-contact-form.vue?vue&type=script&lang=js"
export * from "./new-contact-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7346062a",
  null
  
)

export default component.exports